import { gql } from '@apollo/client'

export interface UserPasswordResetRequestInput {
  email: string
}

export interface UserPasswordResetRequestResponse {
  userPasswordResetRequest: {
    success: boolean
    message?: string
    errors?: string[]
  }
}

export interface UserPasswordResetInput {
  resetPasswordToken: string
  password: string
  passwordConfirmation: string
}

export interface UserPasswordResetResponse {
  userPasswordReset: {
    success: boolean
    user?: {
      id: string
      email: string
    }
    token?: string
    errors?: string[]
  }
}







export const REQUEST_PASSWORD_RESET_MUTATION = gql`
  mutation RequestPasswordReset($input: UserPasswordResetRequestInput!) {
    userPasswordResetRequest(input: $input) {
      success
      message
      errors
    }
  }
`

export const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword($input: UserPasswordResetInput!) {
    userPasswordReset(input: $input) {
      success
      user {
        id
        email
      }
      token
      errors
    }
  }
` 